export default {
	init() {
		$('nav').on('click', '.show .menu-item-has-children', function(){
			$('.menu-item-has-children').not($(this)).removeClass('current-menu-ancestor');
			$(this).toggleClass('current-menu-ancestor');
		})

		if ( $('.notification-banner').length ) {
			console.log(localStorage.getItem('hide-klc-banner'));
			if ( !localStorage.getItem('hide-klc-banner') ) {
				$('.notification-banner').fadeIn();
			}
		}

		$('.banner-toggle').click(function(e){
			e.preventDefault();
			$('.notification-banner').fadeOut();
			localStorage.setItem('hide-klc-banner', true);
		})
	},
	finalize() {
	// JavaScript to be fired on all pages, after page specific JS is fired
	},
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js